/** escape special characters in Solr query fieldValue */
const e = (value: string): string => {
  return value.replace(/([+&|!(){}[\]^"~*?:\\])/g, '\\$1');
};

/** represents a list of filter queries (fq) for Solr */
export default class SolrFq {
  /** all the fq */
  private fqs: string[] = [];

  private readonly op: 'AND' | 'OR';

  private constructor({ op }: { op: 'AND' | 'OR' }) {
    this.op = op;
  }

  /** add a grouping of `${fieldName}:(${fieldValues.join(' ')})` to the fq's */
  public pushGroup(fieldName: string, fieldValues: string[]): SolrFq {
    const group = fieldValues.map((fieldValue) => e(fieldValue));
    // TODO support AND/OR
    this.fqs.push(`${fieldName}:(${group.join(' ')})`);
    return this;
  }

  public push(fieldName: string, fieldValue: string): SolrFq {
    this.fqs.push(`${fieldName}:${e(fieldValue)}`);
    return this;
  }

  public excludePastDates(fieldName: string): SolrFq {
    this.fqs.push(`${fieldName}:[NOW-36HOUR TO *]`);
    return this;
  }

  /** return a new SolrFq with the AND operator */
  public static and(): SolrFq {
    return new SolrFq({
      op: 'AND',
    });
  }

  /** return a new SolrFq with the OR operator */
  public static or(): SolrFq {
    return new SolrFq({
      op: 'OR',
    });
  }

  /** Should only be used in SolrQuery */
  public setUrlParams(url: URL): void {
    url.searchParams.set('q.op', this.op);
    for (const [ii, fq] of this.fqs.entries()) {
      if (ii === 0) {
        url.searchParams.set('fq', fq);
      } else {
        url.searchParams.append('fq', fq);
      }
    }
  }
}
